import { memo, useRef, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'

interface CountdownTileProps {
  value: number
  label: string
  accent?: string
  large?: boolean
}

export const CountdownTile = memo(function CountdownTile({
  value,
  label,
  accent = 'rgba(0,97,255,0.4)',
  large = false,
}: CountdownTileProps) {
  const prevRef = useRef(value)
  const changed = prevRef.current !== value
  useEffect(() => { prevRef.current = value }, [value])

  const display = String(value).padStart(2, '0')

  return (
    <div className="relative flex flex-col items-center gap-1">
      {/* Glow behind number */}
      <div
        className="absolute -top-2 w-10 h-10 rounded-full blur-2xl opacity-40 pointer-events-none"
        style={{ backgroundColor: accent }}
      />
      <AnimatePresence mode="popLayout">
        <motion.span
          key={`${label}-${display}`}
          initial={changed ? { y: -12, opacity: 0, scale: 0.8 } : false}
          animate={{ y: 0, opacity: 1, scale: 1 }}
          exit={{ y: 12, opacity: 0, scale: 0.8 }}
          transition={{ type: 'spring', stiffness: 500, damping: 30 }}
          className={`
            font-display font-extrabold tabular-nums leading-none
            ${large ? 'text-[32px]' : 'text-[22px]'}
          `}
          style={{ color: '#F0F0F5' }}
        >
          {display}
        </motion.span>
      </AnimatePresence>
      <span className="text-[10px] font-medium uppercase tracking-wider text-hint">
        {label}
      </span>
    </div>
  )
})
